import React, { CSSProperties, KeyboardEvent, ReactNode } from 'react';
import { useOpenAnimations } from '../../hooks/common';
import { InnoIcon } from '@innomotics/innomotics-build-react-lib';

interface AccordionProps {
    children: ReactNode;
    label: string;
    open: boolean;
    onClick: () => void;
    style?: CSSProperties;
    closedLabel?: string;
    dark?: boolean;
    icon?: string;
    iconFont?: string;
    incomplete?: boolean;
}

const Accordion = ({ children, closedLabel, dark, icon, iconFont, label, open, onClick, incomplete, style }: AccordionProps) => {
    const [animationClass, handleAnimationEnd, contentRef, height] = useOpenAnimations<HTMLDivElement>(open);

    const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
        if (event.key === ' ') {
            event.preventDefault();
            onClick();
        }
    };

    return (
        <div className={`accordion  ${animationClass} ${dark ? 'dark' : ''}`} tabIndex={0} onKeyDown={handleKeyDown} style={style}>
            <div className={`header ${(icon != null || iconFont != null) ? 'with-icon' : ''}`} onClick={onClick}>
                {(icon != null || iconFont != null) &&
                    <div className={`header-icon ${incomplete ? 'incomplete' : ''}`}>
                        <InnoIcon icon={icon} icon-font={iconFont} size='32' theme='light'></InnoIcon>
                    </div>
                }
                <div className='header-label-container'>
                    {closedLabel &&
                        <div className='header-closed-label'>
                            {closedLabel}
                        </div>
                    }
                    <div className='header-label'>
                        {label}
                    </div>
                </div>
                <div className='header-close-icon' />

            </div>
            <div ref={contentRef} className='header-content-container' style={{ height }} onAnimationEnd={handleAnimationEnd}>
                <div className='header-content'>
                    {children}
                </div>
            </div>
        </div>
    );
};

export default Accordion;
